export const employerSearchOptInSchema = {
  title: "Opt-In to Employer Search",
  logicalname: "Contact",
  type: "object",
  description: "Please choose if you wish to be opted into SAICE Connect Employer Search below and click Save when you have made your changes.",
  properties: {
    ctpt_connectsearch: {
      title: "Opted into SAICE Connect Employment Search",
      type: "string",
      schemaname: "ctpt_connectsearch",
      datatype: "string",
      enum: ["True", "False"],
      enumNames: ["Yes", "No"],
    },
    _ctpt_branchid_value: {
      title: "Province - This will be automatically populated from the selected branch in your profile.",
      type: "string",
      schemaname: "ctpt_branchid",
      datatype: "array",
      disabled: true,
      isDynamic: true,
      apiURL: "/api/GetAllAsync",
      payload: {
        properties: ["ctpt_name", "ctpt_branchid", "ctpt_displayflag"],
        filter: {
          globalfilter: "",
          globalAndOperator: false,
          fieldAndOperator: true,
          filterfields: [
            {
              field: "statecode",
              searchvalue: 0,
              type: "guid",
            },
          ],
        },
        Aggregate: {
          AggregateFields: [],
        },
        sortfield: {
          field: "ctpt_name",
          sorttype: "asc",
        },
        recordtype: "ctpt_branchs",
        idfield: "ctpt_branchid",
        continuationToken: "",
        pazesize: "1000",
      },
      enum: ["1"],
      enumNames: ["1"],
    },
    ctpt_discipline: {
      title: "Discipline(s) - These will be automatically populated from your profile qualifications.",
      type: "string",
      schemaname: "ctpt_discipline",
      datatype: "string",
      disabled: true
    },
    ctpt_qualifications: {
      title: "Qualification(s) - These will be automatically populated from your profile qualifications.",
      type: "string",
      schemaname: "ctpt_qualifications",
      datatype: "string",
      disabled: true
    },
    ctpt_professionalregistration: {
      title: "Professional Registration(s) - These will be automatically populated from your profile.",
      type: "string",
      schemaname: "ctpt_professionalregistration",
      datatype: "string",
      disabled: true
    },
    ctpt_employmentstatus: {
      title: "Employment Status",
      type: "string",
      schemaname: "ctpt_employmentstatus",
      datatype: "string",
      enum: ["533910000", "533910001", "533910003"],
      enumNames: ["Employed", "Unemployed", "Part Time"],
    },
    ctpt_willingtorelocate: {
      title: "Willing to Relocate",
      type: "string",
      schemaname: "ctpt_willingtorelocate",
      datatype: "string",
      enum: ["533910000", "533910001", "533910002"],
      enumNames: ["Yes", "No", "Not Required"],
    },
    ctpt_employmenttype: {
      title: "Employment Type",
      type: "string",
      schemaname: "ctpt_employmenttype",
      datatype: "string",
      enum: ["533910000", "533910001", "533910002", "533910004", "533910005"],
      enumNames: ["Full-Time", "Freelance", "Contract", "Internship", "Graduate Program"],
    },
  },
};

